<template>
	<div class="w1200 page">
		<div class="flex benben-flex-layout flex-wrap align-center myinfo_0">
			<div class="flex myinfo_1 justify-end">
				<div class="myinfo_2">*</div>
				<div>头像：</div>
			</div>
			<el-upload
			  class="avatar-uploader"
			  action="https://yufabu.saizhuge.net/api/m15414/5d5fa8984f0c2"
			  :show-file-list="false"
			  :on-success="handleAvatarSuccess"
			  :before-upload="beforeAvatarUpload">
			  <img v-if="user_detal.avatar" :src="user_detal.avatar" class="avatar">
			  <img v-else class="myinfo_4" src="../../static/image/22.png" alt="" srcset="">
			</el-upload>
		</div>
		<div class="flex benben-flex-layout flex-wrap align-center myinfo_0 ">
			<div class="flex myinfo_1 justify-end">
				<div class="myinfo_2">*</div>
				<div>昵称：</div>
			</div>
			<el-input class="myinfo_3" v-model="user_detal.nickname" placeholder="请输入昵称"></el-input>
		</div>
		<div class="flex benben-flex-layout flex-wrap align-center myinfo_0">
			<div class="flex myinfo_1 justify-end">
				<div class="myinfo_2">*</div>
				<div>手机号：</div>
			</div>
			<el-input class="myinfo_3" disabled v-model="user_detal._mobile" placeholder="请输入手机号"></el-input>
		</div>
		<div class="flex benben-flex-layout flex-wrap align-center myinfo_0">
			<div class="myinfo_1 justify-end">
				<div>生日：</div>
			</div>
			<el-date-picker
			    class="myinfo_3"
				value-format="yyyy-MM-dd"
			    v-model="user_detal.birthday"
			    type="date"
				 :picker-options="pickerOptions3"
			    placeholder="选择日期">
			</el-date-picker>
		
		</div>
		<div class="myinfo_5 pointer" @click="post5cb54af125f1c">保存</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				input1:'',
				input2:'',
				head_img:'',
				imgId:'',
				options1:[
					{
					  value: '1',
					  label: '男'
					}, {
					  value: '2',
					  label: '女'
					}
				],
				value1: '',
				user_detal:'',
				post_type:false,
				pickerOptions3: {
				    disabledDate(time) {
				        // 禁止选择未来日期（不能选择今天）
				        return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
				    },
				},
			}
		},
		created() {
			this.post5c78c4772da97()
			// this.post641568f1b6f87()
		},
		methods:{
			// 修改个人资料
			post5cb54af125f1c(){
				if(!this.user_detal.nickname){
					this.$message.error('请填写昵称');
					return
				}
				
				if(this.post_type){
					return
				}
				
				this.post_type = true
				this.$api.post(this.$apiUrls.post5cb54af125f1c, {
					avatar:this.user_detal.avatar,
					nickname:this.user_detal.nickname,
					birthday:this.user_detal.birthday,
				}).then((res) => {
					if (res.code == 1) {
						this.$message.success('修改成功！');
						this.post_type = false
						this.$emit('ctom-event',''); // 触发事件
					} else {
						this.$message.error(res.msg);
						this.post_type = false
						return
					}
				})
			},
			// 获取个人资料
			post5c78c4772da97(){
				this.$api.post(this.$apiUrls.post5c78c4772da97, {}).then((res) => {
					if (res.code == 1) {
						this.user_detal = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			handleAvatarSuccess(res, file) {
				// console.log(file,123)
				this.user_detal.avatar = file.response.data[0].path
				this.imgId = file.response.data[0].id
			    // this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
			    const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
				  this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			post641568f1b6f87(){
				this.$api.post(this.$apiUrls.post641568f1b6f87, {
					column_id: 1
				}).then((res) => {
					// console.log(res, 123)
					if (res.code == 1) {} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
		},
	}
</script>

<style  lang="scss" scoped>
	::v-deep{
		.avatar-uploader{
			position: relative;
			width: 80px;
			height: 80px;
			margin: 0 0 20px 0;
		}
		.avatar {
		  width: 80px;
		  height: 80px;
		  border-radius: 80px;
		}
	
	}
	.page{
		padding: 30px 0 0 60px;
	}
	.myinfo_0{
		margin-bottom: 20px;
	}
	.myinfo_1{
		width: 100px;
		text-align: right;
		margin: 0 16px 0 0;
	}
	.myinfo_2{
		color: #FE4900;
	}
	.myinfo_3{
		width: 400px !important;
	}
	.myinfo_4{
		width: 80px;
		height: 80px;
	}
	.myinfo_5{
		width: 148px;
		height: 48px;
		background: #004EA1;
		border-radius: 8px 8px 8px 8px;
		color: #fff;
		text-align: center;
		line-height: 48px;
		margin: 50px 0 0 250px;
	}
</style>